export class TableContextSegments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sampleHours",
            "baseName": "sampleHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "sameColumns",
            "baseName": "sameColumns",
            "type": "Array<TableContextSameColumns>",
            "format": ""
        },
        {
            "name": "dimensions",
            "baseName": "dimensions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "outcomes",
            "baseName": "outcomes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "Array<TableContextSegment>",
            "format": ""
        },
        {
            "name": "segmentColumns",
            "baseName": "segmentColumns",
            "type": "Array<TableContextSegmentColumn>",
            "format": ""
        },
        {
            "name": "map",
            "baseName": "map",
            "type": "TableContextSegmentMap",
            "format": ""
        },
        {
            "name": "decided",
            "baseName": "decided",
            "type": "Array<TableContextDecidedColumn>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegments.attributeTypeMap;
    }
    constructor() {
    }
}
